'use strict';

export class DatatableHelper{
	constructor() {

	}

	static tableToArray(table) {
		var headers = [];
		var headerCells = table.querySelectorAll('thead tr > *');
		headerCells.forEach(function(cell) {
			headers.push(cell.textContent.trim());
		});

		var tableData = [];
		var rows = table.querySelectorAll('tbody tr');

		rows.forEach(function(row) {
			var rowData = {};
			var cells = row.cells;
			for (var i = 0; i < cells.length; i++) {
				rowData[headers[i]] = cells[i].textContent.trim();
			}
			tableData.push(rowData);
		});

		return tableData;
	}

	static generateCSVDataSubTables(dataTable) {
		const filteredDataArray = dataTable.rows({ search: 'applied' }).data().toArray();

		const columnNames = dataTable.columns().header().toArray().map(function(header) {
			return header.textContent;
		});

		return filteredDataArray.map(function(rowArray) {
			var obj = {};
			columnNames.forEach(function(columnName, index) {
				let cell = rowArray[index];
				if (cell.includes('<table class="levcharity_datatable_sub_row_table"')){
					let parser = new DOMParser();
					let doc = parser.parseFromString(cell, 'text/html');

					let table = doc.querySelector('table');
					let value = doc.querySelector('.value')?.textContent || '';

					cell = {value: value, subitems: DatatableHelper.tableToArray(table)}
				}

				obj[columnName] = cell;
			});
			return obj;
		});
	}
}
